import Modal from "../Modal/Modal";
import React, { useState, useEffect } from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;


export const ModalDisconnectWarning = (props) => {
 
  const { T: t } = useApp();
  const { open, onClose, onSubmit, method } = props
    
  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="500px"
        className={"!bg-suzu-gray-1"}
        onClose={onClose}
      >
        <ContentWaper>
          <div className={`max-w-full relative transition ease-in-out`}>
            <div className="pb-2 lg:pb-[12px]">
              <p className="text-xl lg:text-2xl text-center text-aia-red font-manrope font-bold h-[31px] whitespace-nowrap">
                {t("Disconnect account")}
              </p>
            </div>
            <div className="pb-2 lg:pb-[12px] mt-[15px] mb-[20px]">
              <p className="text-base text-center font-[400]">
                {t("By disconnecting this account, you will lose access to AI Avatar until you link it again.")}
              </p>
            </div>
            <div className="pb-2 lg:pb-[12px] mt-[15px] mb-[20px]">
              <p className="text-base text-center font-[400]">
                {t("Are you sure you want to disconnect?")}
              </p>
            </div>
          </div>
          <div className="flex justify-center items-center pt-2 lg:pt-3 gap-[15px] flex-col-reverse sm:flex-row">
            <button
              className="w-full sm:w-40 h-[52px] px-5 py-4 bg-white text-black border border-solid border-black text-center rounded-[15px]"
              onClick={()=>onClose()}
            >
              {t("Cancel")}
            </button>
            <button
              className="w-full sm:w-40 h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px]"
              onClick={(e) => onSubmit(e)}
            >
              {t("Disconnect")}
            </button>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
